// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"de4f990b","667":"76ded6fe","977":"2209fdaa"}[chunkId] + ".chunk.js";
};